import { useState } from "react";
import { useLocation, Outlet } from "react-router-dom";
import {
  Building2, Globe, Map, Earth, Handshake, Newspaper, Contact,
  BookOpen, Camera,
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";
import HermesChat from "@/components/HermesChat";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  { id: "internal-matters", label: "Internal Matters", icon: Building2, path: "/knowledge-centre/internal-matters", bgColor: "bg-blue-500", desc: "SOPs, Forms, Policies & more" },
  { id: "thematic-matters", label: "Thematic Matters", icon: Globe, path: "/knowledge-centre/thematic-matters", bgColor: "bg-purple-500", desc: "Political, Economic, Social & more" },
  { id: "national", label: "National", icon: Map, path: "/knowledge-centre/national", bgColor: "bg-green-500", desc: "Provincial information" },
  { id: "continental", label: "Continental", icon: Earth, path: "/knowledge-centre/continental", bgColor: "bg-amber-500", desc: "Africa, Europe, Asia & more" },
  { id: "multilaterals", label: "Multilaterals", icon: Handshake, path: "/knowledge-centre/multilaterals", bgColor: "bg-indigo-500", desc: "UN, AU, EU, BRICS & more" },
  { id: "current-affairs", label: "Current Affairs", icon: Newspaper, path: "/knowledge-centre/current-affairs", bgColor: "bg-orange-500", desc: "News & updates" },
  { id: "contacts", label: "Contacts", icon: Contact, path: "/knowledge-centre/contacts", bgColor: "bg-cyan-500", desc: "Internal & external contacts" },
  { id: "monitored-files", label: "Monitored Files", icon: Camera, path: "/knowledge-centre/monitored-files", bgColor: "bg-cyan-600", desc: "Captured images & video clips" },
];

export default function KnowledgeCentreLayout() {
  const location = useLocation();
  const [agentOpen, setAgentOpen] = useState(true);

  const currentPath = location.pathname;

  const agentToggle = (
    <div className="p-3 border-t border-slate-700">
      <button
        onClick={() => setAgentOpen(!agentOpen)}
        className={`flex items-center gap-3 p-3 rounded-lg transition-all w-full text-left ${
          agentOpen ? "bg-cyan-600 text-white" : "text-slate-400 hover:bg-slate-800 hover:text-white"
        }`}
      >
        <BookOpen className="w-5 h-5 flex-shrink-0" />
        <div className="overflow-hidden">
          <p className="font-medium text-sm">Agent Knowit</p>
          <p className="text-xs opacity-70 truncate">Ask about documents</p>
        </div>
      </button>
    </div>
  );

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="KNOWLEDGE CENTRE"
        subtitle="Document Management"
        icon={BookOpen}
        gradient="from-cyan-500 to-teal-500"
        activeBg="bg-cyan-500"
        sidebarFooter={agentToggle}
      />

      {/* Agent Knowit Panel */}
      {agentOpen && (
        <div className="hidden md:flex w-80 border-l border-app bg-app-card flex-col flex-shrink-0">
          <HermesChat
            contextHint="[Knowledge Centre]"
            title="Agent Knowit"
            icon={BookOpen}
            color="from-cyan-500 to-teal-500"
            accentColor="text-cyan-500"
            layout="sidebar"
            placeholder="Ask about documents..."
            suggestedQuestions={[
              "Get a contact of",
              "Who is",
              "When is",
              "Generate latest report on",
            ]}
            sessionPrefix="knowit"
            showHeader={true}
          />
        </div>
      )}

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
